export default __webpack_public_path__ + "static/media/2.183c0d0c.png";